export function isInViewport (element: Element): boolean {
  const rect = element.getBoundingClientRect()
  return (
    rect.top < window.innerHeight &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.right > 0
  )
}

export function observeWhenVisible (
  element: Element,
  onVisible: () => void,
  rootMargin = '100px'
): IntersectionObserver {
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        onVisible()
        observer.disconnect()
        break
      }
    }
  }, { rootMargin })

  observer.observe(element)
  return observer
}

export function downloadFilename (disposition: string | null, fallback: string): string {
  const header = disposition ?? ''
  const plain = header.match(/(?:^|;)\s*filename="([^"]+)"/i)?.[1] ?? fallback
  const encoded = header.match(/(?:^|;)\s*filename\*=UTF-8''([^;]+)/i)?.[1]
  if (encoded == null) return plain
  try {
    return decodeURIComponent(encoded.trim())
  } catch {
    return plain
  }
}
